import { Skeleton } from '@mui/material';
import { Variant } from '@mui/material/styles/createTypography';

import AtomTypography from '../../atoms/AtomTypography/AtomTypography';

interface IProps {
  variant?: Variant;
  sizeSkeleton?: number;
}

const SkeletonComponent: React.FC<IProps> = (props) => {
  const { variant, sizeSkeleton } = props;
  const range = Array.from(Array(sizeSkeleton ?? 3).keys());

  return (
    <>
      {range.map((index: number) => (
        <AtomTypography data-testid="typography" key={index} component="div" variant={variant ?? 'body1'}>
          <Skeleton data-testid="skeleton" data-cy-skeleton-index={index} animation="wave" />
        </AtomTypography>
      ))}
    </>
  );
};

export default SkeletonComponent;
